export const initActive = function() {
  //   ActiveElement.Start
  const activeElements = document.querySelectorAll('[data-add-active]');

  if (activeElements.length > 0) {
    activeElements.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        el.classList.toggle('is-active');
      });
    });
  }
  //   ActiveElement.End
};
